import { Controller } from '@hotwired/stimulus'
import {headers} from '../../src/js/csrf'

export default class extends Controller {
  static targets = ['attachments']

  initialize() {
    const project = this.data.get('project')
    let url
    if (project) {
      url = `/attachments?project=${project}`
    } else {
      url = '/attachments'
    }
    // attachments lazy load
    fetch(url)
      .then(response => {
        if (!response.ok) { throw response } // moving flow to catch block
        return response.json()
      }).then(res => {
        if (res.html) {
          this.attachmentsTarget.insertAdjacentHTML('afterbegin', res.html)
        }
    }).catch(error => console.error("we got an error:", error))
  }

  // action
  destroyAttachment(event) {
    let attachmentId = event.currentTarget.dataset.uploadId
    let uploadHolder = event.currentTarget.closest('.attachment__holder')
    fetch('/attachments/' + attachmentId, {
      method: 'delete',
      headers: headers,
    }).then(res => {
      uploadHolder.remove()
    }).catch(error => console.error("we got an error:", error))
  }

}
